
@if (title() && startDate()) {
  <main class="card__main">
    <ci-icon 
      class="card__main-icon"
      type="svg" 
      name="location-on"
    ></ci-icon>

    <div class="card__main-info">
      <h2 class="card__main-address ci-paragraph-p1-semibold">
        {{ title() | translate }}
      </h2>
      
      <span class="card__main-time ci-caption-regular">
        {{ 'Llegada a las'  | translate }} 
        {{ startDate() | date: 'HH:mm' }}
      </span>
    </div>
</main>
}
